import { Button } from '@dgshahr/ui-kit'
import Header from '@/components/landing/header/Header'
import Footer from '@/components/landing/footer/Footer'
import { useNavigate } from 'react-router-dom'
import notFound from '~/public/assets/images/Illustration (1).svg'

const ServerError = () => {
  const navigate = useNavigate()

  return (
    <>
      <Header />
      <div className="w-full tablet:h-[700px] bg-gray-100 flex flex-col-reverse tablet:grid tablet:grid-cols-12 items-center">
        <div className="tablet:w-[520px] h-[272px] w-full p-4 tablet:p-2 col-start-3 col-end-7">
          <p className="font-heading-4 text-primary-500 ss02 text-lg font-bold">
            خطای 500
          </p>
          <p className="text-2xl font-bold my-4">پاسخی از سرور دریافت نشد!</p>
          <p className="text-gray-500 font-caption mb-8">
            همکاران ما در حال رفع این مشکل هستند. لطفاً در زمان دیگری مجدداً
            تلاش کنید
          </p>
          <Button variant="outline" onClick={() => navigate('/')}>
            بازگشت به صفحه اصلی
          </Button>
        </div>
        <img
          className="overflow-hidden tablet:!h-[640px] tablet:!w-[546px] h-[350px] mt-10 w-full col-start-8 col-end-12 object-cover"
          src={notFound}
          alt="notfound"
        />
      </div>
      <Footer />
    </>
  )
}

export default ServerError
